import { KnBrDraftOrdersService } from './../../../store/kn-br-draft-orders/kn-br-draft-orders.service';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { CmsService, ContentSlotData, Currency, CurrencyService, TranslatePipe } from '@spartacus/core';
import { ActiveCartService } from '@spartacus/cart/base/core';
import { Observable, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import * as _ from 'lodash';
import { KnBrCommonService } from '../../../services/kn-br-common.service';
import { Actions } from '@ngrx/effects';
import { KnBrDraftOrderItemComponent } from './kn-br-draft-order-item/kn-br-draft-order-item.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'knbr-kn-br-draft-order-items',
    templateUrl: './kn-br-draft-order-items.component.html',
    styleUrls: ['./kn-br-draft-order-items.component.scss'],
    imports: [KnBrDraftOrderItemComponent, AsyncPipe, TranslatePipe]
})
export class KnBrDraftOrderItemsComponent implements OnInit, OnDestroy {
  entries$: Observable<any> = this.activeService.getActive().pipe(
    filter((order) => !order || (order && !!order.entries)),
    map((order) => order.entries),
    map((order) =>
      order.map((entry: any) => ({
        ...entry,
        uniqueId: `${String(entry.entryNumber)}${JSON.stringify(entry.knbrQuoteReference)}${String(
          entry.requestedShipDate
        )}${JSON.stringify(entry.knbrTotalPrice.knbrAbsoluteDiscount)}${entry.quantity}${JSON.stringify(
          entry.knbrTotalPrice.priceAdjusted
        )}${entry.commentCount}`,
      }))
    )
  );
  allChecked = false;

  selectedProductSubscription = new Subscription();
  selectedProductCodes: number[];
  components: ContentSlotData;
  draftHeaderDiscountType$: Observable<boolean> = this.draftOrdersService.loadDiscountType$();
  activeCurrency: string;
  currencyData$: Observable<string> = this.currencyService.getActive();
  constructor(
    protected activeService: ActiveCartService,
    protected knBrCommonService: KnBrCommonService,
    protected draftOrdersService: KnBrDraftOrdersService,
    protected currencyService: CurrencyService,
    protected ref: ChangeDetectorRef,
    protected cmsService: CmsService,
    protected actions$: Actions
  ) {
    this.selectedProductSubscription.add(
      this.currencyData$.subscribe((currency) => {
        this.currencyService.getAll().subscribe((currencies) => {
          if (currency && currencies?.length) {
            const activeCurrencyObj: Currency = _.find(currencies, ['isocode', currency]);
            this.activeCurrency = activeCurrencyObj ? activeCurrencyObj.symbol : null;
          }
        });
      })
    );
    this.selectedProductSubscription = this.knBrCommonService.loadCartEntry().subscribe((selectedProductCodes) => {
      if (selectedProductCodes) {
        this.selectedProductCodes = selectedProductCodes;
        let entryNumbers = [];
        this.entries$
          .subscribe((entries) => {
            entryNumbers = entries.map((entry) => entry.entryNumber);
          })
          .unsubscribe();
        this.allChecked = entryNumbers.length === this.selectedProductCodes.length;
        this.ref.markForCheck();
      }
    });
  }

  ngOnInit(): void {}

  selectAll(event) {
    let entryNumbers = [];
    if (event.currentTarget.checked) {
      this.entries$
        .subscribe((entries) => {
          entryNumbers = entries.map((entry) => entry.entryNumber);
        })
        .unsubscribe();
    }
    this.knBrCommonService.setCartEntry(entryNumbers);
  }

  isDisabled() {
    let editable = true;
    this.cmsService
      .getContentSlot('KnBrDraftOrderItemsSlot')
      .subscribe((value) => (this.components = value))
      .unsubscribe();
    this.activeService
      .getActive()
      .subscribe((value: any) => (editable = value.editable))
      .unsubscribe();
    if (
      (this.components &&
        this.components.components &&
        this.components.components.length &&
        this.components.components[0].flexType === 'KnBrDraftOrderItemsComponentReadOnly') ||
      !editable
    ) {
      return true;
    }

    return false;
  }

  ngOnDestroy(): void {
    if (this.selectedProductSubscription) {
      this.selectedProductSubscription.unsubscribe();
    }
  }
}
